import toast from "react-hot-toast";
import { useDevAgentStore } from "@/stores/devAgentStore";

type OpenTabFile = {
  id: string;
  name: string;
  metadataType: string;
};

/** Add / remove workspace pin in metadata editor header. */
export function EditorWorkspacePinActions({
  activeFile,
  initialContentById,
  orgId,
  busy,
}: {
  activeFile: OpenTabFile | undefined;
  initialContentById: Record<string, string>;
  orgId: string | undefined;
  busy: boolean;
}) {
  const pinnedArtifactIds = useDevAgentStore((s) => s.pinnedArtifactIds);
  if (!activeFile) return null;
  const isPinned = !!pinnedArtifactIds[String(activeFile.id)];

  return (
    <div className="flex items-center gap-1.5">
      {isPinned ? (
        <button
          type="button"
          onClick={() => {
            useDevAgentStore.getState().removeFromArtifacts(String(activeFile.id));
            toast.success(`${activeFile.name} removed from workspace`);
          }}
          disabled={busy}
          className="flex items-center gap-1 px-2.5 py-1 text-xs font-medium bg-red-500/10 text-red-400 hover:bg-red-500/20 border border-red-500/20 rounded transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
        >
          − Remove from Workspace
        </button>
      ) : (
        <button
          type="button"
          onClick={() => {
            const fileId = String(activeFile.id);
            useDevAgentStore.getState().addToArtifacts({
              id: fileId,
              name: activeFile.name,
              metadataType: activeFile.metadataType,
              content: initialContentById[fileId] || "",
            });
            toast.success(`${activeFile.name} added to workspace`);
            const name = activeFile.name;
            void (async () => {
              try {
                const { getMetadataItemByName } = await import("../devAgentService");
                await getMetadataItemByName(name, orgId);
                useDevAgentStore.getState().setArtifactBadge(fileId, "R");
              } catch {
                useDevAgentStore.getState().setArtifactBadge(fileId, "C");
              }
            })();
          }}
          disabled={busy}
          className="flex items-center gap-1 px-2.5 py-1 text-xs font-medium bg-blue-500/10 text-blue-400 hover:bg-blue-500/20 border border-blue-500/20 rounded transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
        >
          + Add to Workspace
        </button>
      )}
    </div>
  );
}
